import styles from './SuccessStorySection.scss?inline';

import {BaseContainer} from "../../base/customComponent/BaseContainer";

class SuccessStorySection extends BaseContainer {
    constructor() {
        super();
        this.customStyle = styles;
    }

    get color(): string {
        return this.dataset.color ?? 'white';
    }

    render() {
        const container = document.createElement('div');
        container.classList.add('success-story-section', `color-${this.color}`);
        container.innerHTML = `
            <header></header>
            <div class="body">
                <slot></slot>
            </div>
            <div class="base-grid">
                <div class="cta"></div>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        container.querySelector('header').append(this.createHeader('horizontal'));
        this.cloneSlotContentIntoContainer(container.querySelector('.cta'), 'cta');
        return container;
    }

}

customElements.define('nxt-success-story-section', SuccessStorySection);
